import PoolBasics, { I18N_CONTEXT } from './create_basics'
import { reduxForm } from 'redux-form'
import formUtils from 'lib/form_utils'
import { length, required, combine, futureDate } from 'lib/validators'
import { endDateValidators } from 'lib/end_date_validators'
import { getI18n } from 'client/i18n'
import { TITLE_LENGTH } from 'shared/lengths'
import { push } from 'react-router-redux'
import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const i18n = getI18n(I18N_CONTEXT)
const { PUBLIC_MONEY_POOL } = POOLS_CAMPAIGN_TYPES

let validators = [
  length('poolName', TITLE_LENGTH, i18n('pool_name_too_long')),
  required('poolName', i18n('pool_name_is_required')),
  futureDate('endDate', i18n('date_must_be_future')),
  ...endDateValidators('endDate', i18n('date_must_be_future')),
]

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    shouldAutoFocus: props.router.params.action !== 'POP',
    initialValues: {
      poolName: campaign.title,
      goalAmount: campaign.goal,
      endDate: campaign.end_date ? new Date(campaign.end_date) : null,
      shareProgress: campaign.share_progress,
    },
  }
}

const mapDispatchToProps = dispatch => ({
  onSubmit(formValues) {
    dispatch(
      setData(NEW_CAMPAIGN_ID, {
        title: formValues.poolName,
        goal: formValues.goalAmount,
        end_date: formValues.endDate,
        share_progress: formValues.shareProgress,
        campaign_type: PUBLIC_MONEY_POOL,
      })
    )
    dispatch(
      push({ pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create/preferences` })
    )
  },
})

export default reduxForm(
  {
    form: 'create_basics',
    destroyOnUnmount: false,
    validate: combine(...validators),
    touchOnBlur: true,
    touchOnChange: false,
    fields: ['poolName', 'goalAmount', 'endDate', 'shareProgress'],
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(PoolBasics))
